const styles = {
  scroll: {
    height: '55vh',
    overflowY: 'auto',
    '&::-webkit-scrollbar': { display: 'none' },
    msOverflowStyle: 'none',
    scrollbarWidth: 'none',
  },
  linear: {
    flex: 1,
    mr: 1,
  },
  qrcode: {
    fontSize: 150,
  },
  hideInput: {
    position: 'absolute',
    opacity: 0,
    pointerEvents: 'none',
  },
  headerContainer: {
    marginBottom: '.5em',
    display: 'flex',
    alignItems: 'start',
    justifyContent: 'space-between',
  },
  backBtn: {
    '&&': {
      marginRight: '.5em',
    },
  },
  title: {
    flex: 1,
    padding: '1px 0',
  },
  btn: {
    alignSelf: 'start',
  },
  formControl: {
    width: '100%',
    maxWidth: 300,
  },
};

export default styles;
